import React, { useState, useEffect } from "react";
import { Button, Dialog, Typography } from "@mui/material";
import { useUserSlice } from "src/store/features/user.slice";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import { Link } from "react-router-dom";
import { trackEvent } from "src/Amplitude";

export default function RekycModal() {
  const isMobile = useIsMobile();
  const {
    reKycDetails: { reKyc, formSubmitted },
  } = useUserSlice();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Suppressed on the standing Re-KYC form and on the adhoc AU/NZ re-KYC
    // page (/adhocKyc) — the standing modal must never pop over that flow.
    const { pathname } = window.location;
    if (reKyc && pathname !== "/reKycApplication" && !pathname.startsWith("/adhocKyc")) {
      setOpen(true);
    }
  }, [reKyc]);

  useEffect(() => {
    if (open) trackEvent("Visit_Modal", { modal: "Re-KYC_Notice" }, "Re-KYC");
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {reKyc && !formSubmitted && (
        <Dialog
          open={open}
          sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div
            style={{
              backgroundColor: "#FFFFFF",
              padding: 30,
            }}>
            <Typography gutterBottom fontSize={isMobile ? "18px" : "30px"} sx={{ fontWeight: 600 }}>
              KYC Re-Verification Required
            </Typography>
            <Typography gutterBottom variant="body1" textAlign="justify">
              As part of our commitment to comply with our Australian Anti-Money Laundering and
              Counter-Terrorism Financing (AML/CTF) regulations, we conduct a regular exercise to
              ensure the accuracy and completeness of the information we hold on your Caleb & Brown
              trading account(s).
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ pb: 2 }} textAlign="justify">
              We kindly request your cooperation in reviewing and updating your customer information
              with us. Please take a few minutes to answer some questions by clicking ‘Proceed’
              below.
            </Typography>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Link to="/reKycApplication" style={{ textDecoration: "none" }}>
                <Button
                  disableRipple
                  variant="contained"
                  style={{
                    marginLeft: "10px",
                    background: "#002035",
                    textTransform: "none",
                    fontWeight: "600",
                  }}
                  onClick={handleClose}>
                  Proceed
                </Button>
              </Link>
              <Button
                disableRipple
                variant="contained"
                style={{
                  background: "#fc4c4c",
                  textTransform: "none",
                  fontWeight: "600",
                }}
                onClick={handleClose}>
                Not Now
              </Button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
}
